// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__3wRMg","nodata":"CustomTable_nodata__2tAKB"};